import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { getFuelingStations, getTripFueling } from "../../api/apiGetrequest";
import {
  AddDriveImage,
  AddTripFueling,
  UpdateOffloadingCheckOUT,
  UpdateTripFueling,
} from "../../api/apirequest";

const ActionModal = ({ isOpen, onClose, shipment, fetchOrders }) => {
  const [formData, setFormData] = useState({
    fuelIssuedLtrs: "",
    fuelIssuedValue: "",
    allowance: "4000",
    otherExpense: "",
    closingRemarks: "",
    finalMileage: "",
    invoiceImage: null,
    fuelStation: null,
    customPrice: "", // New field for custom price
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("fueling");
  const [previousFuelings, setPreviousFuelings] = useState([]);
  const [selectedFueling, setSelectedFueling] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [stations, setStations] = useState([]);

  const fetchData = async () => {
    try {
      const { result } = await getTripFueling(
        shipment?.AllocationID,
        0,
        shipment?.TripDate,
        shipment?.TripDate
      );
      const { result: stations } = await getFuelingStations(
        shipment?.AllocationID,
        0
      );
      setPreviousFuelings(result);
      setStations(stations);
    } catch (error) {
      console.error("Error fetching allocations:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      invoiceImage: file,
    }));
  };

  const handleFuelStationChange = (selectedOption) => {
    const selectedStation = stations.find(
      (station) => station.FuelingStationID === selectedOption.value
    );
    if (selectedStation) {
      setFormData((prev) => ({
        ...prev,
        fuelStation: selectedStation,
        customPrice: selectedStation.Price.toString(), // Set default price
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        fuelStation: null,
        customPrice: "",
      }));
    }
  };

  const calculateFuelValue = () => {
    const price =
      parseFloat(formData.customPrice) || formData.fuelStation?.Price || 0;
    const liters = parseFloat(formData.fuelIssuedLtrs) || 0;
    return (price * liters).toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleTripClosing = async () => {
    try {
      setLoading(true);
      setError("");

      if (!formData.invoiceImage || !(formData.invoiceImage instanceof File)) {
        toast.error("Please upload a valid invoice image.");
        setLoading(false);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(formData.invoiceImage);

      reader.onload = async () => {
        try {
          const base64Image = reader.result.split(",")[1];
          const imageResult = await AddDriveImage({
            base64Image: base64Image,
            fileName: new Date().toISOString(),
          });

          if (imageResult.ViewLink) {
            const { FileId } = imageResult;
            const formPayload = {
              allocationID: shipment?.AllocationID,
              fuelIssuedLtrs: 0,
              fuelIssuedValue: 0,
              claim: formData.allowance || 4000,
              otherExpense: 0,
              closingRemarks: formData.closingRemarks,
              finalMileage: 0,
              shipmentNO: formData.shipmentNO,
              trip: formData.trip,
              casesFull: formData?.casesFull,
              invoiceImage: FileId,
            };

            const result = await UpdateOffloadingCheckOUT(formPayload);

            if (result && result.success) {
              toast.success(result.message || "Trip successfully closed!");
              fetchOrders();
              onClose();
            } else {
              toast.error(result.message || "Failed to close the trip.");
            }
          } else {
            toast.error("Failed to upload the invoice image.");
          }
        } catch (error) {
          console.error("Error during trip closing:", error);
          toast.error("There was an error closing the trip.");
        } finally {
          setLoading(false);
        }
      };

      reader.onerror = () => {
        console.error("Error reading the invoice image.");
        toast.error("Failed to read the invoice image.");
        setLoading(false);
      };
    } catch (error) {
      console.error("Error during trip closing:", error);
      toast.error("There was an error closing the trip.");
      setLoading(false);
    }
  };

  const handleEditFueling = (fueling) => {
    setSelectedFueling(fueling);
    setIsEditing(true);
    setFormData({
      ...formData,
      fuelStation: stations.find(
        (option) => option.FuelingStationID === fueling.FuelingStationID
      ),
      fuelIssuedLtrs: fueling.FuelLitres?.toString(),
      customPrice:
        (fueling.FuelAmount / fueling.FuelLitres)?.toString() ||
        fueling.Price?.toString(),
      TripFuelingID: fueling.TripFuelingID,
    });
  };

  const details = JSON.parse(localStorage.getItem("user"));

  const handleAddandUpdateFueling = async () => {
    try {
      setLoading(true);
      setError("");

      const formPayload = {
        tripFuelingID: formData?.TripFuelingID || 0,
        allocationID: shipment?.AllocationID,
        fuelStationID: formData.fuelStation.FuelingStationID,
        stationName: formData.fuelStation.StationName,
        fuelAmount:
          parseFloat(formData.customPrice) *
          parseFloat(formData.fuelIssuedLtrs),
        fuelLitres: formData.fuelIssuedLtrs,
        statusID: 1,
        addedBy: details.data.userID,
      };

      let result;
      if (isEditing) {
        result = await UpdateTripFueling(formPayload);
      } else {
        result = await AddTripFueling(formPayload);
      }

      if (result && result.success) {
        toast.success(result.message || "Fueling successfully updated!");
        fetchOrders();
        setFormData({
          fuelIssuedLtrs: "",
          fuelIssuedValue: "",
          fuelStation: null,
          customPrice: "",
        });
        setIsEditing(false);
        setSelectedFueling(null);
      } else {
        toast.error(result?.message || "Failed to update fueling.");
      }
    } catch (error) {
      console.error("Error during fueling update:", error);
      toast.error("There was an error updating the fueling.");
    } finally {
      setLoading(false);
      fetchData();
    }
  };

  const renderTripFuelingForm = () => {
    return (
      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ flex: 1 }}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Fuel Station</label>
            <Select
              disabled={isEditing}
              options={stations.map((s) => ({
                label: s.StationName,
                value: s.FuelingStationID,
              }))}
              value={{
                label: formData?.fuelStation?.StationName,
                value: formData?.fuelStation?.FuelingStationID,
              }}
              onChange={handleFuelStationChange}
              placeholder="Select fuel station"
              styles={customSelectStyles}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Fuel Issued (Ltrs)</label>
            <input
              disabled={isEditing}
              type="number"
              name="fuelIssuedLtrs"
              value={formData.fuelIssuedLtrs}
              onChange={handleChange}
              placeholder="Enter fuel issued in liters"
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Price per Liter</label>
            <input
              type="number"
              name="customPrice"
              value={formData.customPrice}
              onChange={handleChange}
              placeholder="Enter custom price"
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Fuel Value</label>
            <input
              disabled
              value={calculateFuelValue()}
              placeholder="Calculated fuel value"
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <button
              type="button"
              onClick={handleAddandUpdateFueling}
              style={{ ...styles.button, width: "100%" }}
            >
              {isEditing ? "Update Fuel Request" : "Add Fuel Request"}
            </button>
            {isEditing && (
              <button
                type="button"
                onClick={() => {
                  setIsEditing(false);
                  setSelectedFueling(null);
                  setFormData({
                    fuelIssuedLtrs: "",
                    fuelIssuedValue: "",
                    fuelStation: null,
                    customPrice: "",
                  });
                }}
                style={{
                  ...styles.button,
                  backgroundColor: "#dc3545",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                Cancel Edit
              </button>
            )}
          </div>
        </div>

        <div
          style={{
            flex: 1,
            maxHeight: "300px",
            overflowY: "auto",
            paddingLeft: "10px",
          }}
        >
          <h4 style={styles.previousFuelingsTitle}>Previous Fuelings</h4>
          {previousFuelings.length === 0 ? (
            <p style={{ color: "#999" }}>No previous fuelings recorded.</p>
          ) : (
            <ul style={styles.previousFuelingsList}>
              {previousFuelings.map((fueling, index) => (
                <li key={index} style={styles.previousFuelingItem}>
                  <span>
                    {`Station: ${fueling.StationName}`} <br />
                    {`Liters: ${fueling.FuelLitres}`} <br />
                    {`Value: ${fueling.FuelAmount}`}
                  </span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditFueling(fueling);
                    }}
                    style={styles.editIcon}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                      fill="#007bff" // Changed to blue for edit icon
                    >
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                    </svg>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  };

  const renderTripClosingForm = () => {
    return (
      <div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Allowance</label>
          <input
            type="number"
            name="allowance"
            value={formData.allowance}
            onChange={handleChange}
            placeholder="Enter allowance"
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>VoyageNO</label>
          <input
            type="number"
            name="shipmentNO"
            value={formData.shipmentNO}
            onChange={handleChange}
            placeholder="Enter VoyangeNO"
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Details*</label>
          <input
            type="text"
            value={formData.trip}
            onChange={(e) => setFormData({ ...formData, trip: e.target.value })}
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Cases Full*</label>
          <input
            type="number"
            value={formData.casesFull}
            onChange={(e) =>
              setFormData({ ...formData, casesFull: e.target.value })
            }
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Closing Remarks</label>
          <input
            type="text"
            name="closingRemarks"
            value={formData.closingRemarks}
            onChange={handleChange}
            placeholder="Enter closing remarks"
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Invoice Image</label>
          <input
            type="file"
            name="invoiceImage"
            onChange={handleFileChange}
            style={styles.input}
            accept="image/*"
          />
        </div>
      </div>
    );
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  if (!isOpen) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>
            Trip Closing - VoyangeNO {shipment.ShipmentNo}
          </h3>
          <button onClick={onClose} style={styles.closeButton}>
            ×
          </button>
        </div>
        <div style={styles.tabContainer}>
          <button
            style={activeTab === "fueling" ? styles.activeTab : styles.tab}
            onClick={() => handleTabChange("fueling")}
          >
            Trip Fueling
          </button>
          <button
            style={activeTab === "closing" ? styles.activeTab : styles.tab}
            onClick={() => handleTabChange("closing")}
          >
            Trip Closing
          </button>
        </div>
        <div style={styles.form}>
          {activeTab === "fueling" && renderTripFuelingForm()}
          {activeTab === "closing" && renderTripClosingForm()}
        </div>
        {activeTab === "closing" && (
          <div style={styles.formGroup}>
            <button
              style={{ ...styles.button, width: "100%" }}
              onClick={handleTripClosing}
              disabled={loading}
            >
              {loading ? "Closing..." : "Close Order"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "5px",
  }),
};

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "600px", // Increased width for better layout
    maxHeight: "90vh",
    overflow: "auto",
    position: "relative",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  modalHeader: {
    padding: "20px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
  },
  modalTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "600",
    color: "#333",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#666",
  },
  tabContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #eee",
  },
  tab: {
    flex: 1,
    padding: "10px 0",
    border: "none",
    backgroundColor: "#f8f9fa",
    cursor: "pointer",
    transition: "all 0.3s ease",
    borderBottom: "2px solid transparent",
  },
  activeTab: {
    flex: 1,
    padding: "10px 0",
    border: "none",
    backgroundColor: "transparent",
    color: "#007bff",
    cursor: "pointer",
    borderBottom: "2px solid #007bff",
    fontWeight: "bold",
  },
  form: {
    padding: "20px",
  },
  formGroup: {
    marginBottom: "15px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    fontSize: "14px",
  },
  button: {
    padding: "10px 20px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    cursor: "pointer",
    borderRadius: "5px",
  },
  previousFuelingsTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  previousFuelingsList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  previousFuelingItem: {
    marginBottom: "5px",
    padding: "5px",
    backgroundColor: "#f8f9fa",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  editIcon: {
    background: "none",
    border: "none",
    color: "#007bff",
    fontSize: "18px",
    cursor: "pointer",
    padding: "0 5px",
  },
};

export default ActionModal;
